<template>
  <el-dialog
    :title="$t('deleteBasePrivilege.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="closeDialog">
    <div class="text-center">
      <p>{{ $t('deleteBasePrivilege.confirmDeletePrivilege') }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('deleteBasePrivilege.cancel') }}</el-button>
      <el-button type="primary" @click="deleteBasePrivilege">{{ $t('deleteBasePrivilege.confirmDelete') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteBasePrivilege } from '@/api/dev/basePrivilegeApi'

export default {
  name: 'DeleteBasePrivilege',
  data() {
    return {
      dialogVisible: false,
      deleteBasePrivilegeInfo: {}
    }
  },
  methods: {
    open(params) {
      this.deleteBasePrivilegeInfo = Object.assign({}, params)
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.deleteBasePrivilegeInfo = {}
      console.log(this.deleteBasePrivilegeInfo)
    },
    deleteBasePrivilege() {
      deleteBasePrivilege(this.deleteBasePrivilegeInfo)
        .then(() => {
          this.$message.success(this.$t('deleteBasePrivilege.deleteSuccess'))
          this.closeDialog()
          this.$emit('success')
        })
        .catch(error => {
          console.error('删除失败:', error)
          this.$message.error(this.$t('deleteBasePrivilege.deleteFailed'))
        })
    }
  }
}
</script>